import { use } from "react";

import { UserContext } from "@/contexts";
import { analytics } from "@/utils/segment";

function useSegmentEvent() {
  const { user } = use(UserContext);

  const sendSegmentEvent = (
    eventName: string,
    extraParams: Record<string, string> = {}
  ) => {
    const payload: Record<string, string> = {
      event_text: eventName,
      ...extraParams,
    };

    if (user) {
      payload.email = user.email;
      payload.user_id = `bolo-${user.id}`;
    }

    analytics.track(eventName, payload);
  };

  return { sendSegmentEvent };
}

export default useSegmentEvent;
